/* eslint-disable unicorn/consistent-function-scoping */
import { Modal, ModalActionNames } from './types';
import { AppThunkDispatch } from '..';

export const setModalOpen = (properties: Modal) => async (dispatch: AppThunkDispatch) => {
  dispatch({
    type: ModalActionNames.OPEN_MODAL,
    payload: properties,
  });
};

export const setModalClosed = () => async (dispatch: AppThunkDispatch) => {
  dispatch({
    type: ModalActionNames.CLOSE_MODAL,
  });
};
